import { useState, useEffect } from 'react'
import { pick } from 'lodash-es'
import { useTitle } from 'react-use'
import { useProjectStore } from '@vt/hooks'
// import useStorage from '../storages/use-storage'

const Title = function (defaultTitle) {
  // const { extras = {} } = useStorage()
  const { customInfo } = useProjectStore((s) => pick(s, ['customInfo']))
  // const { customInfo } = extras
  const { title } = customInfo || {}

  const [showTitle, setShowTitle] = useState()
  useTitle(showTitle || '')

  const updateTitle = (value) => {
    setShowTitle(value)
  }

  useEffect(() => {
    if (defaultTitle) {
      setShowTitle(defaultTitle)
    } else {
      setShowTitle(title)
    }
  }, [defaultTitle])

  return {
    updateTitle,
  }
}

export default Title
